import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isInternalLink, LINK_REL } from 'helpers/ContentHelper';

import style from './SocialMediaLinks.module.scss';

const SocialMediaLinks = ({ links = [], theme = {} }) => {
  if (!links?.length) {
    return null;
  }

  return (
    <div className={classNames(style.container, theme.container)}>
      {links.map(({ text, link, logo }) => {
        const isNullTarget = isInternalLink(link) || !link;
        const anchorProps = {
          key: link,
          href: link,
          target: isNullTarget ? null : '_blank',
          rel: isNullTarget ? null : LINK_REL,
        };
        return (
          <a {...anchorProps} className={classNames(style.link, theme.link)}>
            <div className={classNames(style.logo, theme.logo)}>{logo}</div>
            <div className={classNames(style.linkText, theme.linkText)}>{text}</div>
          </a>
        );
      })}
    </div>
  );
};

SocialMediaLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.string,
      logo: PropTypes.element,
      alt: PropTypes.string,
    }),
  ),
  theme: PropTypes.shape({}),
};

export default SocialMediaLinks;
